import { api } from './client'

export type ProvisioningStatus =
  | 'ready'
  | 'provisioning'
  | 'failed'
  | 'unknown'
  | 'skipped'

export interface ProvisioningStatusResponse {
  tenant_id: number
  provisioning_status: ProvisioningStatus
  account_id: string | null
  operation_id: string | null
  last_error: string | null
}

export const adminTenantsApi = {
  getProvisioningStatus: (tenantId: number) =>
    api
      .get<ProvisioningStatusResponse>(
        `/v1/admin/tenants/${tenantId}/provisioning-status`,
      )
      .then((r) => r.data),

  retryProvisioning: (tenantId: number) =>
    api
      .post<ProvisioningStatusResponse>(
        `/v1/admin/tenants/${tenantId}/provisioning/retry`,
      )
      .then((r) => r.data),

  skipProvisioning: (tenantId: number) =>
    api
      .post<ProvisioningStatusResponse>(
        `/v1/admin/tenants/${tenantId}/provisioning/skip`,
      )
      .then((r) => r.data),
}
